<template>
  <v-app>
    <v-container
      class="justify-center"
      fluid
      fill-height
    >
      <Spinner />
    </v-container>
  </v-app>
</template>

<script>
import Spinner from '@/global/components/Spinner'
export default {
  name: 'LoadingView',

  components: {
    Spinner
  }
}
</script>
